/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteTempoIntegrationInput = {|
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type DeleteTempoIntegrationMutationVariables = {|
  input: DeleteTempoIntegrationInput
|};
export type DeleteTempoIntegrationMutationResponse = {|
  +deleteTempoIntegration: ?{|
    +company: ?{|
      +id: string,
      +tempoOauthTokenApplied: ?boolean,
      +tempoOauthClientId: ?string,
      +tempoOauthClientSecret: ?string,
    |}
  |}
|};
export type DeleteTempoIntegrationMutation = {|
  variables: DeleteTempoIntegrationMutationVariables,
  response: DeleteTempoIntegrationMutationResponse,
|};
*/


/*
mutation DeleteTempoIntegrationMutation(
  $input: DeleteTempoIntegrationInput!
) {
  deleteTempoIntegration(input: $input) {
    company {
      id
      tempoOauthTokenApplied
      tempoOauthClientId
      tempoOauthClientSecret
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteTempoIntegrationInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteTempoIntegrationPayload",
    "kind": "LinkedField",
    "name": "deleteTempoIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tempoOauthTokenApplied",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tempoOauthClientId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tempoOauthClientSecret",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteTempoIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteTempoIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "DeleteTempoIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteTempoIntegrationMutation(\n  $input: DeleteTempoIntegrationInput!\n) {\n  deleteTempoIntegration(input: $input) {\n    company {\n      id\n      tempoOauthTokenApplied\n      tempoOauthClientId\n      tempoOauthClientSecret\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd1971c189ad87af163cacf503b31ffe7';

module.exports = node;
